<template>
  <div class="vg_wrapper">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="单据信息" name="first" :key="'first'">
        <childTab1 />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import MdrlAddMain from '@/views/MessageManagement/MdrlManage/TabChild/MdrlAddMain.vue';
export default {
  name: 'MdrlAdd',
  components: {
    childTab1: MdrlAddMain
  },
  data() {
    return {
      activeName: 'first'
    };
  }
};
</script>

<style scoped></style>
